/**
 * AccountInfoSection Component
 * 입금/출금 계좌 정보 표시 섹션
 */
import React from 'react';
import {
    HeadDepositModalProps,
    HeadGetWithdrawableAmountResponseDto
} from '../types/headWithdraw.types';
import {
    getDepositAccountString,
    getWithdrawAccountString,
    hasWithdrawAccount,
    ACCOUNT_ROW_STYLE
} from './depositModal.helpers';

interface AccountInfoSectionProps {
    /** 계좌 정보 */
    accountInfo: HeadDepositModalProps['accountInfo'];
    /** 출금 가능 금액 정보 */
    withdrawableAmount: HeadGetWithdrawableAmountResponseDto | null;
    /** 입금 계좌 우선 표시 여부 (입금모달: true, 출금모달: false) */
    depositFirst?: boolean;
}

const AccountInfoSection: React.FC<AccountInfoSectionProps> = ({
    accountInfo,
    withdrawableAmount,
    depositFirst = true
}) => {
    const depositAccount = getDepositAccountString(accountInfo, withdrawableAmount);
    const withdrawAccount = getWithdrawAccountString(accountInfo, withdrawableAmount);
    const showWithdrawAccount = hasWithdrawAccount(accountInfo, withdrawableAmount);

    if (depositFirst) {
        return (
            <div className="account-info">
                <div style={ACCOUNT_ROW_STYLE}>입금계좌 {depositAccount}</div>
                {showWithdrawAccount && <div>출금계좌 {withdrawAccount}</div>}
            </div>
        );
    }

    return (
        <div className="account-info">
            <div style={ACCOUNT_ROW_STYLE}>출금계좌 {withdrawAccount}</div>
            <div>입금계좌 {depositAccount}</div>
        </div>
    );
};

export default AccountInfoSection;
